import { useCallback, useEffect, useRef, useState } from 'react';

import * as S from './styles';

import { CardPrimary } from './Cards/CardPrimary/index';
import { CardSecondary } from './Cards/CardSecondary/index';
import { CardTertiary } from './Cards/CardTertiary/index';
import { MiniBanner } from './MiniBanner/index';

import { CardsHomeSpecialProps } from './types';

export const CardsHomeSpecial = (props: CardsHomeSpecialProps) => {
	const {
		mode = 'light',
		rippleColor = 'portoSeguros15',
		primaryCardTitle,
		headingCardPrimary,
		primaryCardMobileImg = 'https://via.placeholder.com/288x186',
		primaryCardPortrailImg = 'https://via.placeholder.com/280x186',
		primaryCardLandscapeImg = 'https://via.placeholder.com/390x186',
		primaryCardDesktopImg = 'https://via.placeholder.com/375x341',
		primaryCardUltraWideImg = 'https://via.placeholder.com/592x453',
		primaryCardText = 'Eu quero',
		primaryCardLinkUrl = '',
		secondaryCardTitle = 'Até 18 caracteres',
		headingCardSecondary,
		headingCardSecondaryProduct1,
		headingCardSecondaryProduct2,
		secondaryCardLinkUrlOne = 'https://www.portoseguro.com.br/',
		secondaryCardExternalLinkOne = true,
		secondaryCardDescriptionOne = 'Até 20 caracteres',
		secondaryCardImageOne = 'https://via.placeholder.com/320x136',
		secondaryCardDescriptionTwo = 'Até 20 caracteres',
		secondaryCardImageTwo = 'https://via.placeholder.com/320x136',
		secondaryCardLinkUrlTwo = 'https://www.portoseguro.com.br/',
		secondaryCardExternalLinkTwo = true,
		tertiaryCardTitle = 'Autorável: até 27 caracteres',
		headingCardTertiary,
		headingCardTertiaryProduct1,
		headingCardTertiaryProduct2,
		headingCardTertiaryProduct3,
		headingCardTertiaryProduct4,
		tertiaryCardLinkUrlOne = 'https://www.portoseguro.com.br/',
		tertiaryCardExternalLinkOne = true,
		tertiaryCardDescriptionOne = '16 caracteres',
		tertiaryCardImageOne = 'https://via.placeholder.com/220x188',
		tertiaryCardLinkUrlTwo = 'https://www.portoseguro.com.br/',
		tertiaryCardExternalLinkTwo = true,
		tertiaryCardDescriptionTwo = '16 caracteres',
		tertiaryCardImageTwo = 'https://via.placeholder.com/220x188',
		tertiaryCardLinkUrlThree = 'https://www.portoseguro.com.br/',
		tertiaryCardExternalLinkThree = true,
		tertiaryCardDescriptionThree = '16 caracteres',
		tertiaryCardImageThree = 'https://via.placeholder.com/220x188',
		tertiaryCardLinkUrlFour = 'https://www.portoseguro.com.br/',
		tertiaryCardExternalLinkFour = true,
		tertiaryCardDescriptionFour = '16 caracteres',
		tertiaryCardImageFour = 'https://via.placeholder.com/220x188',
		tertiaryCardLinkUrl = 'https://www.portoseguro.com.br/',
		tertiaryCardExternalLink = true,
		tertiaryCardLinkDescription = 'Até 30 caracteres',
		miniBannerTitle = 'A conta digital com seguro grátis!',
		miniBannerSubtitle = 'Eu quero',
		miniBannerDescription = 'Tudo para facilitar o seu dia a dia',
		miniBannerAutoDesktop = 'https://via.placeholder.com/123x140',
		miniBannerAutoMobile = 'https://via.placeholder.com/97x110',
		miniBannerLinkUrl = '',
		miniBannerExternalLink = true,
		miniBannerBgColor = '#8043ff',
		sectionTitle,
	} = props;

	const propsValid = (props: CardsHomeSpecialProps) =>
		Object.values(props).every((prop) => prop !== undefined);

	function useIsMounted() {
		const isMounted = useRef(false);

		useEffect(() => {
			isMounted.current = true;

			return () => {
				isMounted.current = false;
			};
		}, []);

		return useCallback(() => isMounted.current, []);
	}

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const isMounted = useIsMounted();

	useEffect(() => {
		if (isMounted()) setIsLoading(false);
	}, [isMounted]);

	return (
		<>
			{!isLoading && propsValid(props) ? (
				<S.Section>
					<S.Card as="article">
						<S.GridContainer mode={mode}>
							<div className="item">
								<CardPrimary
									mode={mode}
									primaryCardTitle={primaryCardTitle}
									primaryCardMobileImg={primaryCardMobileImg}
									primaryCardPortrailImg={primaryCardPortrailImg}
									primaryCardLandscapeImg={primaryCardLandscapeImg}
									primaryCardDesktopImg={primaryCardDesktopImg}
									primaryCardUltraWideImg={primaryCardUltraWideImg}
									primaryCardText={primaryCardText}
									primaryCardLinkUrl={primaryCardLinkUrl}
									rippleColor={rippleColor}
									headingCardPrimary={headingCardPrimary}
									gtmName={sectionTitle}
								/>
							</div>

							<div className="item">
								<CardSecondary
									mode={mode}
									secondaryCardTitle={secondaryCardTitle}
									secondaryCardLinkUrlOne={secondaryCardLinkUrlOne}
									secondaryCardExternalLinkOne={secondaryCardExternalLinkOne}
									secondaryCardDescriptionOne={secondaryCardDescriptionOne}
									secondaryCardImageOne={secondaryCardImageOne}
									secondaryCardDescriptionTwo={secondaryCardDescriptionTwo}
									secondaryCardImageTwo={secondaryCardImageTwo}
									secondaryCardLinkUrlTwo={secondaryCardLinkUrlTwo}
									secondaryCardExternalLinkTwo={secondaryCardExternalLinkTwo}
									rippleColor={rippleColor}
									headingCardSecondary={headingCardSecondary}
									headingCardSecondaryProduct1={headingCardSecondaryProduct1}
									headingCardSecondaryProduct2={headingCardSecondaryProduct2}
									gtmName={sectionTitle}
								/>
							</div>

							<div className="item">
								<CardTertiary
									mode={mode}
									tertiaryCardTitle={tertiaryCardTitle}
									tertiaryCardLinkUrlOne={tertiaryCardLinkUrlOne}
									tertiaryCardExternalLinkOne={tertiaryCardExternalLinkOne}
									tertiaryCardDescriptionOne={tertiaryCardDescriptionOne}
									tertiaryCardImageOne={tertiaryCardImageOne}
									tertiaryCardLinkUrlTwo={tertiaryCardLinkUrlTwo}
									tertiaryCardExternalLinkTwo={tertiaryCardExternalLinkTwo}
									tertiaryCardDescriptionTwo={tertiaryCardDescriptionTwo}
									tertiaryCardImageTwo={tertiaryCardImageTwo}
									tertiaryCardLinkUrlThree={tertiaryCardLinkUrlThree}
									tertiaryCardExternalLinkThree={tertiaryCardExternalLinkThree}
									tertiaryCardDescriptionThree={tertiaryCardDescriptionThree}
									tertiaryCardImageThree={tertiaryCardImageThree}
									tertiaryCardLinkUrlFour={tertiaryCardLinkUrlFour}
									tertiaryCardExternalLinkFour={tertiaryCardExternalLinkFour}
									tertiaryCardDescriptionFour={tertiaryCardDescriptionFour}
									tertiaryCardImageFour={tertiaryCardImageFour}
									tertiaryCardLinkUrl={tertiaryCardLinkUrl}
									tertiaryCardExternalLink={tertiaryCardExternalLink}
									tertiaryCardLinkDescription={tertiaryCardLinkDescription}
									rippleColor={rippleColor}
									headingCardTertiary={headingCardTertiary}
									headingCardTertiaryProduct1={headingCardTertiaryProduct1}
									headingCardTertiaryProduct2={headingCardTertiaryProduct2}
									headingCardTertiaryProduct3={headingCardTertiaryProduct3}
									headingCardTertiaryProduct4={headingCardTertiaryProduct4}
									gtmName={sectionTitle}
								/>
							</div>

							<div className="item" tabIndex={0}>
								<MiniBanner
									miniBannerTitle={miniBannerTitle}
									miniBannerSubtitle={miniBannerSubtitle}
									miniBannerDescription={miniBannerDescription}
									miniBannerAutoDesktop={miniBannerAutoDesktop}
									miniBannerAutoMobile={miniBannerAutoMobile}
									miniBannerLinkUrl={miniBannerLinkUrl}
									miniBannerExternalLink={miniBannerExternalLink}
									miniBannerBgColor={miniBannerBgColor}
								/>
							</div>
						</S.GridContainer>
					</S.Card>
				</S.Section>
			) : (
				<S.Section>
					<S.Card>
						<S.GridContainer>
							<div className="item">
								<CardPrimary
									isLoading={true}
									mode={mode}
									headingCardPrimary={headingCardPrimary}
									gtmName={sectionTitle}
								/>
							</div>
							<div className="item">
								<CardSecondary
									isLoading={true}
									mode={mode}
									headingCardSecondary={headingCardSecondary}
									headingCardSecondaryProduct1={headingCardSecondaryProduct1}
									headingCardSecondaryProduct2={headingCardSecondaryProduct2}
									gtmName={sectionTitle}
								/>
							</div>
							<div className="item">
								<CardTertiary
									isLoading={true}
									mode={mode}
									headingCardTertiary={headingCardTertiary}
									headingCardTertiaryProduct1={headingCardTertiaryProduct1}
									headingCardTertiaryProduct2={headingCardTertiaryProduct2}
									headingCardTertiaryProduct3={headingCardTertiaryProduct3}
									headingCardTertiaryProduct4={headingCardTertiaryProduct4}
									gtmName={sectionTitle}
								/>
							</div>
							<div className="item">
								<MiniBanner isLoading={true} />
							</div>
						</S.GridContainer>
					</S.Card>
				</S.Section>
			)}
		</>
	);
};
